
import store from '@/store/index';

/**
 * 是否有相应系统及系统相应的菜单 
 */
export const isHasSystemPerm = function (perms) {
    if (!perms.length) {
        return false;
    }
    return perms.some(i => {
        let arr = i.split(':')
        let systemCode = arr.shift();
        let menuCode = arr
        let l = store.getters.tenantSystemCode[systemCode];
        if (l) {
            if (menuCode.length) {
                return l.some((j) => {
                    return menuCode.includes(j)
                })
            } else {
                return true;
            }
        } else {
            return false;
        }
    })
}

export const hasSystemPerm = (Vue) => {
    Vue.directive("hasSystemPerm", (el, binding) => {
        let perms = binding.value;
        if (perms) {
            if (!isHasSystemPerm(perms)) {
                el.parentNode && el.parentNode.removeChild(el);
            }
        } else {
            throw new Error(
                "need perms! Like v-has-system-perm=\"['systemCode:menuCode']\""
            )
        }
    })
}